import React, { FunctionComponent } from 'react';
import { chevronDown } from '@mlc/symbols';
import * as Styled from './styled';

type Props = {
	id?: string;
	placeholder?: string;
	name: string;
	value: string | Array<string>;
	options: Array<any>;
	onChange: (e: any) => void;
	multiple: boolean;
	ariaDescribedby?: string;
	ariaLabelledby?: string;
	dataId?: string;
};

const Select: FunctionComponent<Props> = ({
	id,
	placeholder,
	name,
	value,
	options,
	multiple,
	onChange,
	ariaDescribedby,
	ariaLabelledby,
	dataId,
}) => {
	return (
		<Styled.SelectContainer>
			<Styled.SelectStyle
				onChange={onChange}
				data-id={dataId}
				id={id}
				name={name}
				value={value || ''}
				multiple={multiple}
				size={5}
				aria-describedby={ariaDescribedby}
				aria-labelledby={ariaLabelledby}
			>
				{placeholder ? (
					<option value="" disabled>
						{placeholder}
					</option>
				) : null}
				{options.map(x => (
					<option key={x.value} value={x.value} title={x.label}>
						{x.label}
					</option>
				))}
			</Styled.SelectStyle>
		</Styled.SelectContainer>
	);
};

export default Select;
